import { render, staticRenderFns } from "./ProductPage.vue?vue&type=template&id=5090b98c&scoped=true"
import script from "./ProductPage.vue?vue&type=script&lang=js"
export * from "./ProductPage.vue?vue&type=script&lang=js"
import style0 from "./ProductPage.vue?vue&type=style&index=0&id=5090b98c&prod&lang=css"
import style1 from "./ProductPage.vue?vue&type=style&index=1&id=5090b98c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5090b98c",
  null
  
)

export default component.exports